/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CallConfiguration, CreateCallEventRequest, CreateCallRequest } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Call<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name CallEventCreate
   * @request POST:/call/{callId}/call-event
   */
  callEventCreate = (callId: string, data: CreateCallEventRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/call/${callId}/call-event`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name CallCreate
   * @request POST:/call/{callId}
   */
  callCreate = (callId: string, data: CreateCallRequest, params: RequestParams = {}) =>
    this.request<CallConfiguration, any>({
      path: `/call/${callId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
